import React from 'react'
import PropTypes from 'prop-types'
import { useStyles } from '../styles'
import { useVaultContext } from '../../VaultContextProvider'
import { defaultDocumentDetailsLabel } from '../../constants'

export const DocumentDetailCreatedByUserBlock = ({
  document
}) => {
  const classes = useStyles()
  const { labels } = useVaultContext()

  return (
    <div className={classes.detailsBlock}>
      <div className={classes.detailBlockTitle}>
        {labels?.documentDetails?.createdBy ?? defaultDocumentDetailsLabel.createdBy}
      </div>

      <div className={classes.detailBlockContent}>
        {document.createdByUser?.firstName} {document.createdByUser?.lastName}
      </div>
    </div>
  )
}

DocumentDetailCreatedByUserBlock.propTypes = {
  document: PropTypes.object.isRequired
}
